module.exports = __webpack_public_path__ + "img/hr.hr85eb7e0.svg";